import { sendSlackMessage } from "../../models/notifications";
import { getIPAddress } from "../../models/locationHelpers";
import { useNavigate } from "react-router-dom";

const partnersList = [
  {
    id: 1,
    image: "https://firebasestorage.googleapis.com/v0/b/pabloo-inc.appspot.com/o/partnerships%2Fexternal_partnerships%2Fup_promote_banner.webp?alt=media&token=eb2ee712-af83-4e9c-84c7-741bc62f0047",
    logo: "https://firebasestorage.googleapis.com/v0/b/pabloo-inc.appspot.com/o/partnerships%2Fexternal_partnerships%2Fup_promote_logo.webp?alt=media&token=bfee2fdc-621f-4337-a957-25a7e114db5b",
    title: "UpPromote Affiliate Marketing",
    description: "UpPromote has everything you need to run your affiliate program completed with custom rules, commissions, and trackers in 4 steps.",
    badge: "Built for Shopify",
    cta: "https://partners.secomapp.com/apps/affiliate/Pabloo_app",
  },
  {
    id: 2,
    image: "https://firebasestorage.googleapis.com/v0/b/pabloo-inc.appspot.com/o/partnerships%2Fexternal_partnerships%2Fdoran_banner.webp?alt=media&token=b2073691-87d2-4054-8249-bef9e07b6cac",
    logo: "https://firebasestorage.googleapis.com/v0/b/pabloo-inc.appspot.com/o/partnerships%2Fexternal_partnerships%2Fdoran_logo.webp?alt=media&token=3b0ef2c7-3d52-4f42-9584-30980a54ecd1",
    title: "Doran Product Reviews App & QA",
    description: "Send review requests with discounts to gather photo reviews and video reviews by product reviews app.",
    badge: "Free",
    cta: "https://apps.shopify.com/doran-reviews-questions?utm_source=pabloo",
  },
  {
    id: 3,
    image: "https://firebasestorage.googleapis.com/v0/b/pabloo-inc.appspot.com/o/partnerships%2Fexternal_partnerships%2Fklaviyo_banner.webp?alt=media&token=5837c4a5-e1c1-48a4-acf8-170ec37f6214",
    logo: "https://firebasestorage.googleapis.com/v0/b/pabloo-inc.appspot.com/o/partnerships%2Fexternal_partnerships%2Fklaviyo_logo.webp?alt=media&token=4e8e726c-4815-4d3f-92a7-52d81d7a4381",
    title: "Klaviyo: Email Marketing & SMS",
    description: "Enable 1:1 communications at scale and grow your business by connecting with your customers through text or email.",
    badge: "Free",
    cta: "https://apps.shopify.com/klaviyo-email-marketing?st_source=autocomplete",
  },
  {
    id: 4,
    image: "https://firebasestorage.googleapis.com/v0/b/pabloo-inc.appspot.com/o/partnerships%2Fexternal_partnerships%2FLangWill_1600x900.png?alt=media&token=55b5d019-22c1-4188-aa49-ba4b6d60e052",
    logo: "https://firebasestorage.googleapis.com/v0/b/pabloo-inc.appspot.com/o/partnerships%2Fexternal_partnerships%2FLangwill_logo?alt=media&token=e6e37c0c-e090-4a20-a3ee-5465afded1cb",
    title: "Langwill: AI Language Translate",
    description: "Translate your store into 138 languages and auto-convert currencies to grow sales worldwide.",
    badge: "Free",
    cta: "https://share.channelwill.com/app/16681abc5552453U7j",
  },
];

function PartnerCard({ title, description, image, logo, badge, cta }) {
  const handleClick = () => {
    getIPAddress((ip) => {
      sendSlackMessage(`${ip} is visiting an app partner: ${title}`, "#website-updates");
    });
    if (cta) window.open(cta, "_blank");
  };

  return (
    <div
      onClick={handleClick}
      className="bg-white rounded-xl overflow-hidden cursor-pointer flex flex-col"
      style={{ boxShadow: "0 1px 4px rgba(0,0,0,0.08)", transition: "box-shadow 0.15s" }}
      onMouseEnter={(e) => { e.currentTarget.style.boxShadow = "0 4px 16px rgba(0,0,0,0.12)"; }}
      onMouseLeave={(e) => { e.currentTarget.style.boxShadow = "0 1px 4px rgba(0,0,0,0.08)"; }}
    >
      {image && (
        <img src={image} alt={title} className="w-full object-cover" style={{ aspectRatio: "16/9" }} loading="lazy" />
      )}

      <div className="flex flex-col flex-1 p-5">
        <div className="flex items-center gap-3 mb-3">
          {logo && (
            <img src={logo} alt={`${title} logo`} className="rounded-lg flex-shrink-0" style={{ width: "40px", height: "40px", objectFit: "cover" }} loading="lazy" />
          )}
          <h3 className="font-semibold text-gray-900 text-sm leading-snug">{title}</h3>
        </div>

        {badge && (
          <span className="inline-block text-xs font-semibold px-2 py-0.5 rounded-full mb-3" style={{ background: "rgba(22,163,74,0.1)", color: "#16a34a", width: "fit-content" }}>
            {badge}
          </span>
        )}

        <p className="text-sm text-gray-500 leading-relaxed flex-1">{description}</p>

        <button
          type="button"
          onClick={(e) => { e.stopPropagation(); handleClick(); }}
          className="mt-4 text-sm font-semibold px-4 py-2 rounded-lg self-start"
          style={{ background: "#14532d", color: "#fff" }}
        >
          Learn more
        </button>
      </div>
    </div>
  );
}

function RequestCard() {
  const navigate = useNavigate();
  return (
    <div
      onClick={() => navigate("/partners/join")}
      className="rounded-xl cursor-pointer flex flex-col items-center justify-center text-center p-8 border-2 border-dashed"
      style={{ borderColor: "rgba(255,255,255,0.3)", minHeight: "200px" }}
    >
      <div className="text-white text-3xl mb-3" style={{ opacity: 0.7 }}>+</div>
      <h3 className="font-semibold text-white text-sm mb-2">Request a partnership</h3>
      <p className="text-sm" style={{ color: "rgba(255,255,255,0.65)", lineHeight: 1.5 }}>
        Submit a proposal for your app or agency. If it meets the Pabloo standard, we'll welcome you as a partner.
      </p>
    </div>
  );
}

export default function ListOfPartners() {
  return (
    <div id="partners" style={{ background: "#14532d" }}>
      <div className="mx-auto px-4 sm:px-8 lg:px-16 py-16 sm:py-20" style={{ maxWidth: "1280px" }}>
        <h2 className="font-bold text-white text-2xl sm:text-3xl mb-10">
          Get the best apps for bigger businesses
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {partnersList.map((partner) => (
            <PartnerCard key={partner.id} {...partner} />
          ))}
          <RequestCard />
        </div>
      </div>
    </div>
  );
}
